import { ErrorHandler, isDevMode } from '@angular/core';
import { captureException, preloadSentry } from '@core/sentry-lazy';

export class SentryErrorHandler implements ErrorHandler {

  constructor() {
    // Browser only: initializing the browser SDK during SSR/prerendering keeps
    // zone timers alive forever and the render never stabilizes. The lazy facade
    // fetches and initializes the SDK during an idle slot instead of at bootstrap,
    // keeping ~127 kB out of the initial bundle.
    if (typeof window !== 'undefined' && !isDevMode()) {
      preloadSentry();
    }
  }

  handleError(error: any) {
    if (isDevMode()) {
      console.error(error);
    } else {
      captureException(error);
    }
  }
}

export function provideErrorHandler() {
  return new SentryErrorHandler();
}
